module.exports = __webpack_public_path__ + "img/0.5.37aa6330.png";